import { render, staticRenderFns } from "./Clairvoyance.vue?vue&type=template&id=61370172&scoped=true&"
import script from "./Clairvoyance.vue?vue&type=script&lang=js&"
export * from "./Clairvoyance.vue?vue&type=script&lang=js&"
import style0 from "./Clairvoyance.vue?vue&type=style&index=0&id=61370172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61370172",
  null
  
)

export default component.exports